import { render, staticRenderFns } from "./MessageContentCard.vue?vue&type=template&id=364f31f0&scoped=true"
import script from "./MessageContentCard.vue?vue&type=script&lang=js"
export * from "./MessageContentCard.vue?vue&type=script&lang=js"
import style0 from "./MessageContentCard.vue?vue&type=style&index=0&id=364f31f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364f31f0",
  null
  
)

export default component.exports